import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery('Order', `_id`)
